import { Badge } from "@/components/ui";

export function EstadoBadge({ activo }: { activo: boolean }) {
  return (
    <Badge size="sm" color={activo ? "exito" : "slate"}>
      {activo ? "Activo" : "Inactivo"}
    </Badge>
  );
}
